import { Component, OnInit } from '@angular/core';
import { Outcome } from 'src/app/models/outcomes/Outcome';
import { ModalController, AlertController } from '@ionic/angular';
import { UnfocusElementService } from 'src/app/services/unfocus-element.service';
import { ValidationService } from 'src/app/services/validation.service';
import { DeepCopyService } from 'src/app/services/deep-copy.service';
import { OutcomeGroupsService } from 'src/app/services/outcome-groups.service';
import { OutcomeGroupOutcomeRelation } from 'src/app/models/outcomes/OutcomeGroupOutcomeRelation';
import { MessagesService } from 'src/app/services/messages.service';

@Component({
  selector: 'app-add-sub-outcome-to-outcome-modal',
  templateUrl: './add-sub-outcome-to-outcome-modal.page.html',
  styleUrls: ['./add-sub-outcome-to-outcome-modal.page.scss'],
})
export class AddSubOutcomeToOutcomeModalPage implements OnInit {

  public shouldAddNewOutcome: boolean;
  public shouldAddExisting: boolean;
  public outcomeGroupId;
  public selectedOutcomes: Outcome[] = [];
  public subOutcomes;
  public subOutcomesCopy: Outcome[] = [];
  public subOutcomeCount: number;
  public searchNotFound = false;
  public outcome = {} as Outcome;
  public outcomeSearchTerm;
  public minDate = new Date().toISOString();
  public subOutcomesOriginal: Outcome[] = [];

  constructor(
    public modalController: ModalController,
    public unfocusService: UnfocusElementService,
    public validationService: ValidationService,
    public deepCopyService: DeepCopyService,
    public outcomeGroupService: OutcomeGroupsService,
    public alertController: AlertController,
    public messageService: MessagesService
  ) {
  }

  ngOnInit() {
    this.subOutcomesCopy = this.deepCopyService.deepCopy(this.subOutcomes);
    this.subOutcomesOriginal = this.deepCopyService.deepCopy(this.subOutcomes);
  }

  closeModal() {
    this.resetOutcomeLists();
    this.modalController.dismiss();
  }

  searchBySubOutcome(event) {
    this.updateCopy();
    let title: string = event.target.value;
    this.subOutcomes = this.deepCopyService.deepCopy(this.subOutcomesCopy);
    var outcomes = this.subOutcomes.filter(x => x.title.toLowerCase().includes(title.toLowerCase()));
    if (outcomes.length == 0) {
      this.searchNotFound = true;
      this.subOutcomes = this.deepCopyService.deepCopy(this.subOutcomesCopy);
    }
    else {
      this.searchNotFound = false;
      this.subOutcomes = outcomes;
    }
  }

  updateCopy() {
    this.subOutcomesCopy.forEach(x => {
      var found = this.subOutcomes.find(y => y.outcomeId == x.outcomeId);
      if (found) {
        x.checked = found.checked;
      }
    });
  }

  resetOutcomeLists() {
    this.subOutcomesCopy.forEach(x => {
      x.checked = false;
    });

    this.subOutcomes.forEach(x => {
      x.checked = false;
    });
  }

  addSubOutcome(ev) {
    this.unfocusService.unfocus(ev);
    if (this.shouldAddExisting) {
      var selected = [] as OutcomeGroupOutcomeRelation[];
      var toRemove = [] as OutcomeGroupOutcomeRelation[];
      this.updateCopy();

      for (let i = 0; i < this.subOutcomesOriginal.length; i++) {
        let orginal = this.subOutcomesOriginal[i];
        let updated = this.subOutcomesCopy[i];
        if (orginal.checked != updated.checked) {
          let outcomeGroupOutcomeRelation = {} as OutcomeGroupOutcomeRelation;
          outcomeGroupOutcomeRelation.outcomeGroupId = 0;
          outcomeGroupOutcomeRelation.outcomeGroupId = this.outcomeGroupId;
          outcomeGroupOutcomeRelation.outcomeId = this.deepCopyService.deepCopy(updated.outcomeId);

          if (updated.checked) {
            selected.push(outcomeGroupOutcomeRelation);
          }
          else {
            toRemove.push(outcomeGroupOutcomeRelation);
          }
        }
      }
      if (selected.length != 0 || toRemove.length != 0) {
        this.outcomeGroupService.UpdateSubOutcomes(selected, toRemove).then(x => {
          this.messageService.updatedSuccessfully("Sub Outcomes");
          this.modalController.dismiss();
        });
      }
    }
    else {
      this.saveOutcome();
    }
  }

  setNegativeToZero(event) {
    if (event.target.value < 0) {
      event.target.value = 0;
    }
  }

  async saveOutcome() {
    this.outcome.title = this.validationService.removeHtmlTags(this.outcome.title);
    if (this.validationService.isOutcomeValid(this.outcome)) {
      if (!this.outcome.credits) {
        this.outcome.credits = 0;
      }
      if (this.validationService.checkOutcomeDate(new Date(this.outcome.expiryDate))) {
        await this.outcomeGroupService.addNewOutcomeWithGroup(this.outcome, this.outcomeGroupId).then(x => {
          this.messageService.addedSuccessfully("Sub Outcome");
          this.modalController.dismiss();
        });
      }
      else {
        this.alertForIncorrectData("You have entered an incorrect expiry date.");
      }

    } else {
      this.validationService.alertForMissingOutcomeProperties(this.outcome);
    }

  }

  async alertForIncorrectData(message: string) {
    const alert = await this.alertController.create({
      header: 'Outcome Error: ' + message,
      buttons: [{
        text: 'Ok',
      }
      ]
    });
    await alert.present();
  }

}

